import React from "react";
import { Card, CardHeader, CardContent, Typography } from "@mui/material";


const CustomCard = React.forwardRef(({ className, ...props }, ref) => (
  <Card ref={ref} sx={{ borderRadius: 2, ...className }} {...props} />
));
CustomCard.displayName = "Card";

const CustomCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <CardHeader ref={ref} sx={{ p: 2, ...className }} {...props} />
));
CustomCardHeader.displayName = "CardHeader";

const CustomCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <Typography ref={ref} variant="h6" sx={{ fontSize: "1rem", fontWeight: "medium", ...className }} {...props} />
));
CustomCardTitle.displayName = "CardTitle";

const CustomCardContent = React.forwardRef(({ className, ...props }, ref) => (
  <CardContent ref={ref} sx={{ p: 2, pt: 0, ...className }} {...props} />
));
CustomCardContent.displayName = "CardContent";

export { CustomCard as Card, CustomCardHeader as CardHeader, CustomCardTitle as CardTitle, CustomCardContent as CardContent };